// extracted by mini-css-extract-plugin
module.exports = {"candorInput":"CandorInput_candorInput__FsDHT","label":"CandorInput_label__3UBut","hasPlaceholder":"CandorInput_hasPlaceholder__2oVb3"};